import React from 'react';
import styled from 'styled-components';
import Game from '../game/Game';
import { ProgramInterface } from './ProgramInterface';

const Wrapper = styled.div`
  grid-column-start: 2;
  grid-column-end: 5;
  grid-row: 2;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Program = () => {
	return (
		<Wrapper>
			<ProgramInterface>
				<Game/>
			</ProgramInterface>
		</Wrapper>
	);
};

export default Program;